import { FC, ReactNode } from 'react';
import { Box, Checkbox, CheckboxProps, FormControlLabel, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type IFormCheckboxProps = {
  id: string;
  name: string;
  label: ReactNode;
} & CheckboxProps;

const FormCheckbox: FC<IFormCheckboxProps> = ({ id, name, label, ...otherProps }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Box>
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                size="small"
                checked={!!field.value}
                inputProps={{ 'aria-label': 'controlled' }}
                {...field}
                {...otherProps}
              />
            }
            label={label}
            labelPlacement="end"
            sx={{ width: '100%', gap: 2 }}
          />
          <FormHelperText error={!!errors[name]}>
            {errors[name] ? errors[name].message : ''}
          </FormHelperText>
        </Box>
      )}
    />
  );
};

export default FormCheckbox;
